/**
 * Plain English for the machine codes Tab Service returns on a check. The API's
 * own `message` is already readable; this is the sentence that says what the
 * code means for this account, which the message cannot know.
 *
 * Only codes that need explaining are here. Anything missing falls back to the
 * message alone.
 */
export const issueCodeExplanation: Record<string, string> = {
  DUPLICATE_FILE: 'This exact file has already been filed for this account.',
  DUPLICATE_RECORD_REF: 'Two or more rows share one recordRef. One row per return: it is how a return is matched to the one it corrects or replaces.',
  DUPLICATE_RECORDS: 'These records were filed before. Correct the accepted records instead of filing them again.',
  UNKNOWN_RECORD_REF: 'This recordRef is not an accepted record of this e-file.',
  RECORD_NOT_ACCEPTED: 'The IRS never accepted this record, so there is nothing to correct.',
  RECORD_IN_FLIGHT: 'A correction for this record is still being processed.',
  PARENT_NOT_ACKNOWLEDGED: 'The IRS has not acknowledged this filing yet, so it cannot be corrected.',
  PARENT_NOT_REJECTED: 'This filing was not rejected, so it cannot be replaced. Submit corrections instead.',
  ALREADY_REPLACED: 'A replacement has already been filed for this e-file.',
  GRACE_WINDOW_EXPIRED: 'The IRS grace window for a replacement has closed. Submit corrections instead.',
  UNKNOWN_PRIOR_REFERENCE: 'This prior e-file reference does not match anything Tab Service has filed for this account.',
  TRANSMISSION_TYPE_MISMATCH: 'The transmission type declared in the file does not match what is being submitted.',
  NAME_TIN_CONFLICT: 'The name and the taxpayer ID disagree on whether this is a person or a business. Add separate name columns so it is clear which it is.',
  NAME_UNCERTAIN: 'Tab Service was not sure whether this name is a person or a business. Check it on Resolve Names before uploading, or add separate name columns.',
};

export function explanationFor(code: string): string | undefined {
  return issueCodeExplanation[code];
}
